import { Component, ErrorInfo, ReactNode } from 'react'
import { trackException } from '@/services/appInsights'
import { UnhandledErrorOverlay } from './UnhandledErrorOverlay'

interface State {
  error: Error | null
  errorId: string | null
}

interface Props {
  children: ReactNode
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null, errorId: null }

  static getDerivedStateFromError(error: Error): State {
    return { error, errorId: crypto.randomUUID() }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    trackException(error, {
      errorId: this.state.errorId ?? '',
      componentStack: info.componentStack ?? '',
    })
  }

  render() {
    if (this.state.error && this.state.errorId) {
      return <UnhandledErrorOverlay errorId={this.state.errorId} />
    }

    return this.props.children
  }
}
